// import fetch from 'isomorphic-fetch';
import axios from 'axios';
// const Qs = require('qs');
import * as types from '../store/mutation-type';
import store from '../store/index';
import Alert from "~/components/Alert";
import qs from 'qs';

/**
 * 封装fetch
 * @param path
 * @param params
 * @returns {*|Promise|Promise.<T>|Promise<U>}
 */
export default function toFetch(path, params, config) {
  let {
    url = import.meta.env.VITE_APP_ENV == 'development' ? '' : '/act/blc_carnival2024',
    type = 'POST',
    contextType = 'application/x-www-form-urlencoded'
  } = config || {};

  url = /ztxl/.test(path) ? path : `${url}${path}`;

  console.log(qs.stringify(params))
  let promise = type === 'POST' ? axios({
    method: 'post',
    url: url,
    withCredentials: true,
    headers: {
      'Content-Type': contextType
    },
    data: qs.stringify(params)
  }) : axios.get(url, {params, withCredentials: true});

  return promise
    .then(res => {
      if(/info/.test(url)) {
        // alert(`info api status: ${res.data.status}`);
      }
      // store.commit(types.SHOW_LOADING, false);
      if (res.data) {
        if (res.data.status == 1 || res.data.ret == 1) {
          return res.data;
        } else {
          Alert(res.data.msg || `网络异常，status: ${res.data.status}`)
          // return Promise.reject()
        }
      }
    })
    .catch(() => {
      Alert('请求出错，请稍后重试')
      return Promise.reject()
    })
}
